module.exports = "/global_cta_new-7e70a6e83517ea891e12fe48091d6b1c.svg";